module.exports = __webpack_public_path__ + "r-v3/img/media_white.17c5f418.svg";